export function fetchTmInfo(apiUrl, accessToken, territory) {
    return fetch(`${apiUrl}/v1/tmInfo/${territory}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
}
